import React, { useState } from 'react';
import FormContainer from 'components/LoanForm/FormContainer';
import ToggleButton, { ToggleButtonType } from 'components/ToggleButton';
import Button from 'components/Button';
import { FlowComponentType } from 'routes/types';
import { useDispatch } from 'react-redux';
import { setYourGoalData, LoanGoal } from 'handlers/yourGoal';
import { useLocation } from 'react-router-dom';
import { YourGoalResult } from 'enums/FlowNextResults';
import { setYourIncomeVariant, YourIncomeVariant } from 'handlers/yourIncome';

import styles from './LoanGoals.module.scss';

const goalsList = Object.freeze([
  { title: 'Get out of debt faster', value: LoanGoal.GetOutDebtFaster },
  { title: 'Consolidate my debt', value: LoanGoal.ConsolidateDebt },
  { title: 'Lower my monthly payment', value: LoanGoal.LowerMonthlyPayment },
  { title: 'Lower my interest rate', value: LoanGoal.LowerInterestRate },
  { title: 'Fund a personal expense', value: LoanGoal.FundPersonalExpense },
]);

export enum YourGoalVariant {
  Default,
  CardCrossSell,
}

const LoanGoals = ({ handleNext }: FlowComponentType) => {
  const [selectedGoalsList, setSelectedGoalsList] = useState<LoanGoal[]>([]);
  const state = useLocation().state as { variant?: YourGoalVariant };
  const variant = state?.variant ?? YourGoalVariant.Default;

  const dispatch = useDispatch();

  const handleGoalChange = (selectedValue: LoanGoal) => {
    setSelectedGoalsList((prev) =>
      prev.includes(selectedValue) ? prev.filter((goal) => goal !== selectedValue) : [...prev, selectedValue],
    );
  };

  const handleNextClick = () => {
    dispatch(setYourGoalData({ loanGoal: JSON.stringify(selectedGoalsList) }));
    if (variant === YourGoalVariant.CardCrossSell) {
      dispatch(setYourIncomeVariant(YourIncomeVariant.CardCrossSell));
      handleNext(YourGoalResult.CardCrossSell);
    } else {
      handleNext();
    }
  };

  const canSubmit = selectedGoalsList.length > 0;

  return (
    <div className={styles.container}>
      <FormContainer title="What are your goals?">
        <div className={styles.goalsContainer}>
          {goalsList.map((option) => (
            <ToggleButton
              key={option.value}
              type={ToggleButtonType.Checkbox}
              onClick={handleGoalChange}
              selected={selectedGoalsList.includes(option.value)}
              {...option}
            />
          ))}
        </div>
        <Button onClick={handleNextClick} disabled={!canSubmit}>
          Next
        </Button>
      </FormContainer>
    </div>
  );
};

export default LoanGoals;
